import { MeshReflectorMaterial } from "@react-three/drei";
import { useLoader } from "@react-three/fiber";
import { TextureLoader, RepeatWrapping } from "three";
import { useEffect } from "react";
import { useFrame } from "@react-three/fiber";
import { ANIMATION_SPEED, GROUND_SPEED_MULTIPLIER } from '../constants';

const commonMaterialProps = {
    envMapIntensity: 0,
    dithering: true,
    color: [0.015, 0.015, 0.015],
    blur: [1000, 400],
    mixBlur: 30,
    mixStrength: 80,
    mixContrast: 1,
    resolution: 512,
    depthScale: 0.01,
    minDepthThreshold: 0.9,
    maxDepthThreshold: 1,
    depthToBlurRatioBias: 0.25,
    debug: 0,
    reflectorOffset: 0.2
};

export function Ground({ isMoving }) {
    const [roughness, normal] = useLoader(TextureLoader,[
        process.env.PUBLIC_URL + "textures/terrain-roughness.jpg",
        process.env.PUBLIC_URL + "textures/terrain-normal.jpg",
    ]);

    useEffect(() => {
        [normal, roughness].forEach((t) => {
            t.wrapS = t.wrapT = RepeatWrapping;
            t.repeat.set(5, 5);
            t.minFilter = t.magFilter = 1003; // LinearFilter
            t.needsUpdate = true;
        });
    }, [normal, roughness]);

    useFrame((state, delta) => {
        if (isMoving) {
            const offset = delta * ANIMATION_SPEED * GROUND_SPEED_MULTIPLIER;
            normal.offset.y -= offset;
            roughness.offset.y -= offset;
        }
    });

    return (
        <mesh rotation-x={-Math.PI * 0.5} receiveShadow>
            <planeGeometry args={[30, 30]} />
            <MeshReflectorMaterial
                {...commonMaterialProps}
                roughness={0.7}
                normalMap={normal}
                normalScale={[0.15, 0.15]}
                roughnessMap={roughness}
            />
        </mesh>
    );
}

export function Asphalt({ isMoving }) {
    const [roughness, normal] = useLoader(TextureLoader,[
        process.env.PUBLIC_URL + "textures/asphalt-roughness.jpg",
        process.env.PUBLIC_URL + "textures/exp.jpg",
    ]);

    useEffect(() => {
        [normal, roughness].forEach((t) => {
            t.wrapS = t.wrapT = RepeatWrapping;
            t.repeat.set(5, 5);
            t.minFilter = t.magFilter = 1003; // LinearFilter
            t.needsUpdate = true;
        });
    }, [normal, roughness]);

    useFrame((state, delta) => {
        if (isMoving) {
            const offset = delta * ANIMATION_SPEED * GROUND_SPEED_MULTIPLIER;
            normal.offset.y -= offset;
            roughness.offset.y -= offset;
        }
    });

    return (
        <mesh rotation-x={-Math.PI * 0.5} receiveShadow>
            <planeGeometry args={[30, 30]} />
            <MeshReflectorMaterial
                {...commonMaterialProps}
                roughnessMap={roughness}
                normalMap={normal}
                roughness={0.5}
                normalScale={[0.4, 0.4]}
            />
        </mesh>
    );
}
